module.exports = __webpack_public_path__ + "img/single-vel-btn3.8b075fc9.png";